(function () {
  const REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const PRIMARY_TAB_COUNT = 4;

  function getElementTop(el) {
    return el.getBoundingClientRect().top + window.scrollY;
  }

  function getElementBottom(el) {
    return el.getBoundingClientRect().bottom + window.scrollY;
  }

  function getSiteHeaderBottom() {
    const header = document.querySelector('.td-header-wrapper');
    if (!header) return 0;
    const bottom = Math.round(header.getBoundingClientRect().bottom);
    return bottom > 0 ? bottom : 0;
  }

  function getJumpBar() {
    return document.querySelector('[data-td-jump-bar]');
  }

  function updateJumpNavTop() {
    const top = getSiteHeaderBottom();
    document.documentElement.style.setProperty('--td-jump-nav-top', top + 'px');
    const bar = getJumpBar();
    const jumpH = bar ? bar.offsetHeight : 60;
    document.documentElement.style.setProperty('--td-jump-nav-height', jumpH + 'px');
    return top + jumpH + 16;
  }

  function parseTabLabels(root) {
    const raw = root.getAttribute('data-td-jump-nav-labels');
    if (!raw) return [];

    try {
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }

  function getJumpNavTargets() {
    return Array.from(document.querySelectorAll('[data-td-jump-nav-target]')).filter((el) => {
      return !el.closest('product-info') && !el.closest('[data-td-jump-nav]');
    });
  }

  function getLabelText(value) {
    return typeof value === 'string' && value.trim() !== '' ? value.trim() : null;
  }

  function getTabLabel(labelConfig, target, index) {
    const desktop =
      getLabelText(labelConfig && labelConfig.desktop) ||
      getLabelText(target.getAttribute('data-td-jump-nav-label')) ||
      'Tab ' + (index + 1);
    const mobile =
      getLabelText(labelConfig && labelConfig.mobile) ||
      getLabelText(labelConfig && labelConfig.desktop) ||
      getLabelText(target.getAttribute('data-td-jump-nav-label-mobile')) ||
      getLabelText(target.getAttribute('data-td-jump-nav-label')) ||
      desktop;

    return { desktop, mobile };
  }

  function buildJumpNavTabs(root) {
    const labels = parseTabLabels(root);
    const targets = getJumpNavTargets();
    const primary = root.querySelector('[data-td-jump-nav-primary]');
    const secondary = root.querySelector('[data-td-jump-nav-secondary]');

    if (!primary || !secondary) return [];

    primary.textContent = '';
    secondary.textContent = '';

    return targets.map((target, index) => {
      const { desktop, mobile } = getTabLabel(labels[index], target, index);
      const row = index < PRIMARY_TAB_COUNT ? primary : secondary;
      const tab = document.createElement('a');

      tab.href = '#';
      tab.setAttribute('role', 'tab');
      tab.setAttribute('data-td-sticky-tab', '');
      tab.setAttribute('data-td-tab-index', String(index));
      if (index === 0) {
        tab.classList.add('active');
      }

      const desktopLabel = document.createElement('span');
      desktopLabel.className = 'jumpnav__label jumpnav__label--desktop';
      desktopLabel.textContent = desktop;

      const mobileLabel = document.createElement('span');
      mobileLabel.className = 'jumpnav__label jumpnav__label--mobile';
      mobileLabel.textContent = mobile;

      tab.appendChild(desktopLabel);
      tab.appendChild(mobileLabel);
      row.appendChild(tab);

      return { tab, target, index };
    });
  }

  function initJumpNav(root) {
    const standaloneWrapper = root.closest('.shopify-section--td-product-jump-nav');
    let tabsConfig = buildJumpNavTabs(root);

    if (!tabsConfig.length) {
      root.hidden = true;
      return;
    }

    tabsConfig = tabsConfig.slice().sort((a, b) => getElementTop(a.target) - getElementTop(b.target));

    let activeIndex = -1;
    let ticking = false;
    let suppressSpyUntil = 0;

    function updateStandaloneStickyState() {
      if (!standaloneWrapper || !tabsConfig.length) return;

      const headerBottom = getSiteHeaderBottom();
      const jumpHeight = root.offsetHeight || 60;
      const wrapperTop = getElementTop(standaloneWrapper);
      const lastTarget = tabsConfig[tabsConfig.length - 1].target;
      const boundaryBottom = getElementBottom(lastTarget);
      const fixedStart = wrapperTop - headerBottom;
      const releaseStart = boundaryBottom - headerBottom - jumpHeight;
      const shouldFix = window.scrollY >= fixedStart && window.scrollY < releaseStart;
      const shouldRelease = window.scrollY >= releaseStart;
      const releaseOffset = Math.max(jumpHeight, boundaryBottom - jumpHeight - wrapperTop);

      standaloneWrapper.style.setProperty('--td-jump-nav-release-offset', releaseOffset + 'px');
      standaloneWrapper.classList.toggle('is-td-jump-nav-fixed', shouldFix);
      standaloneWrapper.classList.toggle('is-td-jump-nav-released', shouldRelease);
    }

    function setActive(index, options) {
      const opts = options || {};
      if (index < 0 || index >= tabsConfig.length) return;
      if (index === activeIndex) return;
      activeIndex = index;
      tabsConfig.forEach((entry, i) => {
        const isActive = i === index;
        entry.tab.classList.toggle('active', isActive);
        entry.tab.classList.toggle('is-active', isActive);
        entry.tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
      if (opts.scrollTabIntoView) {
        tabsConfig[index].tab.scrollIntoView({
          behavior: REDUCED_MOTION ? 'auto' : 'smooth',
          block: 'nearest',
          inline: 'center',
        });
      }
    }

    function updateActiveFromScroll() {
      if (Date.now() < suppressSpyUntil) return;

      const scrollLine = window.scrollY + updateJumpNavTop();
      let currentIndex = 0;
      let bestTop = -Infinity;

      tabsConfig.forEach((entry, index) => {
        const top = getElementTop(entry.target);
        if (top <= scrollLine + 4 && top > bestTop) {
          bestTop = top;
          currentIndex = index;
        }
      });

      setActive(currentIndex);
    }

    function scrollToTarget(entry) {
      suppressSpyUntil = Date.now() + (REDUCED_MOTION ? 100 : 1400);
      entry.target.scrollIntoView({
        behavior: REDUCED_MOTION ? 'auto' : 'smooth',
        block: 'start',
      });
    }

    function onScroll() {
      updateJumpNavTop();
      updateStandaloneStickyState();
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        updateActiveFromScroll();
        ticking = false;
      });
    }

    tabsConfig.forEach((entry) => {
      entry.tab.addEventListener('click', (event) => {
        event.preventDefault();
        const configIndex = tabsConfig.indexOf(entry);
        if (configIndex < 0) return;
        setActive(configIndex, { scrollTabIntoView: true });
        scrollToTarget(entry);
      });
    });

    updateJumpNavTop();
    updateStandaloneStickyState();
    updateActiveFromScroll();

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener(
      'resize',
      () => {
        tabsConfig = tabsConfig.slice().sort((a, b) => getElementTop(a.target) - getElementTop(b.target));
        updateJumpNavTop();
        updateStandaloneStickyState();
        updateActiveFromScroll();
      },
      { passive: true }
    );
  }

  function boot() {
    document.querySelectorAll('[data-td-jump-nav]').forEach(initJumpNav);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
